import React from 'react';
import PropTypes from 'prop-types';
import Text from 'react-svg-text';

import styles from './MembershipCard.css';

export default class MembershipCard extends React.Component {
  static propTypes = {
    businessName: PropTypes.string,
    memberId: PropTypes.number,
    memberSince: PropTypes.string,
  };

  render() {
    const {businessName, memberId, memberSince} = this.props;
    const memberFontStyle = {
      fill: '#333333',
      fontFamily: '"Montserrat",sans-serif',
      fontWeight: '700',
      fontSize: '9px',
    };
    const memberDetailFontStyle = {
      fill: '#333333',
      fontFamily: '"Montserrat",sans-serif',
      fontWeight: '400',
      fontSize: '9px',
      lineHeight: '10px',
      color: '#333333',
    };

    const isLongBusinessName = businessName.length > 30;

    return (
      <div className={styles.mbrCardContainer}>
        <canvas className={styles.mbrCardCanvas} width="3" height="2" />
        <svg
            width="100%"
            height="100%"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={styles.mbrCardSvg}
            viewBox="0 0 234 156"
        >
          <g id="Member_Card">
            <rect x="0.1" y="61" style={{fill: '#F5F6F7'}} width="100%" height="62%" />
            <rect x="0.1" style={{fill: '#333333'}} width="100%" height="40%" />
            <g id="NFIB_Logo">
              <g>
                <polygon style={{fill: '#ffffff'}} points="20.2,44.8 43.2,44.8 20.2,21.7 					"/>
                <polygon style={{fill: '#ffffff'}} points="33.5,21.7 43.2,31.5 43.2,21.7 					"/>
              </g>
              <g>
                <g>
                  <path style={{fill: '#ffffff'}} d="M54.5,24.8l4.6,8.2v-8.2h5v16.7h-4.5l-4.6-8.2v8.2h-5V24.8H54.5z"/>
                  <path style={{fill: '#ffffff'}} d="M79,24.8l-0.5,4h-5.9v3h5.5l-0.5,3.9h-5v5.8h-5.3V24.8H79z"/>
                  <path style={{fill: '#ffffff'}} d="M86.9,41.6h-5.4v-8.4v-8.4h5.4v8.4V41.6z"/>
                  <path style={{fill: '#ffffff'}} d="M90.4,41.6V24.8h7.8c1,0,1.8,0.1,2.5,0.3c0.7,0.2,1.2,0.5,1.7,0.9c0.4,0.4,0.7,0.9,0.9,1.4
                    c0.2,0.5,0.3,1.1,0.3,1.7v0.3c0,0.7-0.2,1.4-0.5,1.9c-0.3,0.6-0.8,1-1.5,1.4c0.8,0.3,1.3,0.8,1.7,1.4c0.4,0.6,0.6,1.3,0.6,2.2
                    v0.3c0,0.8-0.1,1.4-0.4,2c-0.3,0.6-0.6,1.1-1.2,1.5c-0.5,0.4-1.2,0.7-2,1c-0.8,0.2-1.8,0.3-3,0.3H90.4z M95.3,31.2h2.3
                    c0.4,0,0.7-0.1,0.9-0.3c0.2-0.2,0.3-0.5,0.3-0.9v-0.2c0-0.8-0.4-1.2-1.2-1.2h-2.2V31.2z M95.3,37.8h2.3c0.5,0,0.8-0.1,1-0.4
                    c0.2-0.3,0.4-0.6,0.4-1v-0.3c0-0.5-0.1-0.8-0.4-1c-0.2-0.2-0.6-0.4-1.1-0.4h-2.3V37.8z"/>
                </g>
                <g>
                  <path style={{fill: '#ffffff'}} d="M103.8,41.2h-0.2v-0.8h-0.3v-0.2h0.8v0.2h-0.3V41.2z M104.7,41L104.7,41l-0.3-0.5v0.7h-0.2v-0.9h0.2
                    l0.3,0.4l0.3-0.4h0.2v0.9H105v-0.7L104.7,41z"/>
                </g>
              </g>
            </g>
            <text transform={`matrix(0.9987 0 0 1 19.3186 ${108.376 + (isLongBusinessName ? 18 : 0)})`}>
              <tspan x="0" y="0" style={memberFontStyle}>Member ID:</tspan>
              <tspan x="53" y="0" style={memberDetailFontStyle}> {memberId}</tspan>
            </text>
            <text transform={`matrix(0.9987 0 0 1 19.3186 ${122.8906 + (isLongBusinessName ? 18 : 0)})`}>
              <tspan x="0" y="0" style={memberFontStyle} >Member Since:</tspan>
              <tspan x="67.8" y="0" style={memberDetailFontStyle}> {memberSince}</tspan>
            </text>
            <text transform="matrix(0.9987 0 0 1 19.3186 94.1973)">
              <tspan x="0" y="0" style={memberFontStyle}>Business:</tspan>
              {!isLongBusinessName && (
                <tspan x="42.5" y="0" style={memberDetailFontStyle}> {businessName}</tspan>
              )}
            </text>
            {isLongBusinessName && (
              <Text x="6" dx="6" y="88" height="20" width="160" verticalAnchor="start" style={memberDetailFontStyle}>{businessName}</Text>
            )}
          </g>
        </svg>

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App/account/components/MembershipCard/index.js